module.exports = __webpack_public_path__ + "fonts/b475f36.TTF";